import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=2a70ebc4&scoped=true"
import script from "./InviteModal.vue?vue&type=script&lang=js"
export * from "./InviteModal.vue?vue&type=script&lang=js"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=2a70ebc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70ebc4",
  null
  
)

export default component.exports